import React, { useState, useEffect } from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';
import { useNavigate } from 'react-router-dom';

const Carosel = () => {
  const { isDarkMode } = useDarkMode();
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const slides = [
    {
      id: 'slide-1',
      promo: 'Promo Terbatas',
      title: 'Internet Fiber Super Cepat',
      description: 'Nikmati kecepatan internet hingga 1 Gbps dengan teknologi fiber optik terdepan. Streaming 4K, gaming online, dan video conference tanpa buffering!',
      icon: 'https://telnet.net.id/assets/adataceh.png',
      backgroundImage: 'https://telnet.net.id/assets/bg.png',
      overlay: 'linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(224,249,218,0.9) 100%)',
      ctaText: 'Daftar Sekarang',
      action: () => navigate('/register'),
    },
    {
      id: 'slide-2',
      title: 'Telnet Lag Gaming Experience',
      description: 'Paket khusus gamers dengan ping rendah dan koneksi stabil. Dilengkapi gaming gear premium untuk pengalaman bermain yang maksimal.',
      icon: 'https://telnet.net.id/assets/adataceh.png',
      backgroundImage: 'https://telnet.net.id/assets/bg.png',
      overlay: 'linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(224,249,218,0.9) 100%)',
      ctaText: 'Upgrade Gaming',
      action: () => navigate('/gaming'),
    },
    {
      id: 'slide-3',
      title: 'Infrastruktur World-Class',
      description: 'Hosting dan cloud services dengan infrastruktur data center Tier 3. Keamanan berlapis dan uptime 99.9% untuk bisnis Anda.',
      icon: 'https://telnet.net.id/assets/adataceh.png',
      backgroundImage: 'https://telnet.net.id/assets/bg.png',
      overlay: 'linear-gradient(135deg, rgba(255,255,255,0.85) 0%, rgba(224,249,218,0.9) 100%)',
      ctaText: 'Konsultasi Gratis',
      action: () => navigate('/customer-service'),
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative overflow-hidden w-full" style={{ height: '70vh', minHeight: '400px', maxHeight: '600px' }}>
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${index === currentSlide ? 'opacity-100' : 'opacity-0'} flex items-center w-full h-full`}
          style={{
            backgroundImage: `url(${slide.backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0" style={{ background: slide.overlay }}></div>

          <div className="section-container flex flex-col md:flex-row items-center justify-between relative z-10 w-full">
            <div className="md:w-1/2 mb-6 md:mb-0 text-center md:text-left text-gray-900">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight tracking-tight">
                {slide.title}
              </h1>
              <p className="text-base md:text-lg mb-6 opacity-80 max-w-md mx-auto md:mx-0 leading-relaxed">
                {slide.description}
              </p>
              <button
                onClick={slide.action}
                className="btn-primary"
              >
                {slide.ctaText}
              </button>
            </div>

            <div className="md:w-1/2 flex justify-center">
              {slide.icon && (
                <img
                  src={slide.icon}
                  alt={slide.title}
                  className="w-[280px] h-[280px] md:w-[380px] md:h-[380px] object-contain"
                  style={{ animation: 'float 3s ease-in-out infinite' }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              )}
            </div>
          </div>
        </div>
      ))}

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-2 rounded-full transition-all duration-300 ${index === currentSlide ? 'bg-[#1E9B4C] w-6' : 'bg-gray-400/50 w-2 hover:bg-gray-400'}`}
          />
        ))}
      </div>

      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-12px); }
          100% { transform: translateY(0px); }
        }
      `}</style>
    </div>
  );
};

export default Carosel;
